import type { ApiRoute, NoBody, NoQueryParams } from "../api"
import type { ActionMenuView } from "../common"

export interface GetActionMenuPathParams {
	inventoryId: string
}

export const getActionMenuViewRoute: ApiRoute<GetActionMenuPathParams, NoQueryParams, NoBody, ActionMenuView> = {
	buildUrl: (params) => `vehicles/${params.inventoryId}/actionMenu`,
	method: "get",
	path: "/vehicles/:inventoryId/actionMenu",
}
